import { Box, Grid, Stack } from '@mui/material'
import React from 'react'
import ItemMenuMega from './item-menu-mega'
import { ContainerCustom } from '@/components/common/container-custom'

type PropsOpenMegaMenu = {
  open: boolean
  categories: ICategoryMenu | null | undefined
}

export default function MegaMenuMainBar({ open, categories }: PropsOpenMegaMenu) {
  if (!categories) return null
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '100%',
        left: '0%',
        width: '100%',
        maxWidth: '100%',
        ml: '0 !important',
        zIndex: 10,
        background: 'white',
        border: '1px solid #e0e0e0',
        opacity: open ? 1 : 0,
        visibility: open ? 'visible' : 'hidden',
        transition: 'opacity 0.3s ease, visibility 0.3s ease',
      }}
    >
      <ContainerCustom component={'div'}>
        <Box
          sx={{
            px: 0,
            py: 2,
            minHeight: '10rem',
          }}
        >
          <Grid container columns={12} spacing={2}>
            <Grid size={12}>
              <Grid container columns={12} spacing={2}>
                {categories?.children.map((item) =>
                  item.include_in_menu === 0 || item?.children?.length === 0 ? null : (
                    <Grid key={item.uid} size={3}>
                      <ItemMenuMega item={item} />
                    </Grid>
                  )
                )}
              </Grid>
            </Grid>
            {/* <Grid size={3}>
              <MegaProducts />
            </Grid> */}
          </Grid>
        </Box>
      </ContainerCustom>
    </Box>
  )
}
